import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ExportService } from './layout/export-overlay/export-overlay.service';
import { ExportStoreService } from './layout/export-overlay/export-overlay.store';
import { UserService } from './core/user/user.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { Subject, takeUntil } from 'rxjs';
import { User } from './core/user/user.types';
import { environment } from 'environments/environment.prod';
import { FuseAlertComponent } from '@fuse/components/alert';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, FuseAlertComponent],
    providers: [ExportService, ExportStoreService],
})
export class AppComponent {
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _userService: UserService,
        private permissionsService: NgxPermissionsService
    ) {}

    ngOnInit(): void{
        this._userService.user$
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((user: User) => {
            if(user == null)
            return
            
            if(environment.hasPermission){
                this.permissionsService.flushPermissions();  // Limpia permisos de la librería

                let permissions = []
                try {
                    permissions = JSON.parse(localStorage.getItem('permissions'))
                    if(!Array.isArray(permissions))
                        permissions = []
                } catch (e) {}

                // Agregar permisos a la librería
                for (let permission of permissions)
                    this.permissionsService.addPermission(permission)
                }
        });
    }
}
